var _defs, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "playstore",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M130,40H5a4.951,4.951,0,0,1-5-5V5A4.951,4.951,0,0,1,5,0H130a4.951,4.951,0,0,1,5,5V35A4.951,4.951,0,0,1,130,40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M130,.8A4.225,4.225,0,0,1,134.2,5V35a4.225,4.225,0,0,1-4.2,4.2H5A4.225,4.225,0,0,1,.8,35V5A4.225,4.225,0,0,1,5,.8H130m0-.8H5A5.015,5.015,0,0,0,0,5V35a4.951,4.951,0,0,0,5,5H130a4.951,4.951,0,0,0,5-5V5A5.015,5.015,0,0,0,130,0Z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M47.4,10.2a2.724,2.724,0,0,1-.7,2A3.1,3.1,0,0,1,41.4,10a3.073,3.073,0,0,1,3.1-3.1,2.663,2.663,0,0,1,1.2.3,2.178,2.178,0,0,1,.9.7l-.5.5a1.865,1.865,0,0,0-1.6-.7,1.99,1.99,0,0,0-1.6.7,2.06,2.06,0,0,0-.7,1.7,2.06,2.06,0,0,0,.7,1.7,2.575,2.575,0,0,0,1.6.7,2.193,2.193,0,0,0,1.7-.7,1.656,1.656,0,0,0,.5-1.2H44.5V9.8h2.9v.4ZM52,7.7H49.3V9.6h2.5v.7H49.3v1.9H52V13H48.5V7H52ZM55.3,13h-.8V7.7H52.8V7H57v.7H55.3Zm4.6,0V7h.8v6Zm4.2,0h-.8V7.7H61.6V7h4.1v.7H64V13Zm9.5-.8A3.1,3.1,0,0,1,68.3,10a3.1,3.1,0,1,1,6.2,0A2.94,2.94,0,0,1,73.6,12.2Zm-3.8-.5a2.36,2.36,0,0,0,1.6.7,1.99,1.99,0,0,0,1.6-.7,2.413,2.413,0,0,0,.7-1.7A2.06,2.06,0,0,0,73,8.3a2.36,2.36,0,0,0-1.6-.7,1.99,1.99,0,0,0-1.6.7,2.413,2.413,0,0,0-.7,1.7A2.06,2.06,0,0,0,69.8,11.7ZM75.6,13V7h.9l2.9,4.7V7h.8v6h-.8L76.3,8.1V13h-.7Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M68.1,21.8a4.207,4.207,0,0,0-4.3,4.3,4.268,4.268,0,0,0,4.3,4.3,4.207,4.207,0,0,0,4.3-4.3A4.149,4.149,0,0,0,68.1,21.8Zm0,6.8a2.608,2.608,0,0,1,0-5.2A2.422,2.422,0,0,1,70.5,26,2.482,2.482,0,0,1,68.1,28.6Zm-9.3-6.8a4.207,4.207,0,0,0-4.3,4.3,4.268,4.268,0,0,0,4.3,4.3,4.207,4.207,0,0,0,4.3-4.3A4.149,4.149,0,0,0,58.8,21.8Zm0,6.8a2.608,2.608,0,0,1,0-5.2A2.422,2.422,0,0,1,61.2,26,2.482,2.482,0,0,1,58.8,28.6ZM47.7,23.1v1.8H52a3.781,3.781,0,0,1-1,2.3,4.426,4.426,0,0,1-3.3,1.3A4.656,4.656,0,0,1,43,23.7a4.717,4.717,0,0,1,4.7-4.8A4.958,4.958,0,0,1,51,20.2l1.3-1.3a6.408,6.408,0,0,0-4.5-1.8,6.746,6.746,0,0,0-6.7,6.6,6.746,6.746,0,0,0,6.7,6.6,5.755,5.755,0,0,0,4.6-1.9A6.02,6.02,0,0,0,54,24.2a3.75,3.75,0,0,0-.1-1.1H47.7Zm45.4,1.4a3.885,3.885,0,0,0-3.6-2.7,4.028,4.028,0,0,0-4,4.3,4.185,4.185,0,0,0,4.2,4.3,4.1,4.1,0,0,0,3.5-1.9l-1.4-1a2.437,2.437,0,0,1-2.1,1.2,2.17,2.17,0,0,1-2.1-1.3L93.3,25l-.2-.5Zm-5.8,1.4a2.429,2.429,0,0,1,2.2-2.5,1.769,1.769,0,0,1,1.6.9l-3.8,1.6ZM82.6,30h1.9V17.5H82.6Zm-3-7.3a3.293,3.293,0,0,0-2.3-1A4.3,4.3,0,0,0,73.2,26a4.141,4.141,0,0,0,4.1,4.2,2.871,2.871,0,0,0,2.2-1h.1v.6a2.273,2.273,0,0,1-4.4,1l-1.6.7A4.125,4.125,0,0,0,77.4,34c2.2,0,4-1.3,4-4.4V22H79.6v.7Zm-2.2,5.9a2.608,2.608,0,0,1,0-5.2A2.406,2.406,0,0,1,79.7,26,2.406,2.406,0,0,1,77.4,28.6Zm24.4-11.1H97.3V30h1.9V25.3h2.6a3.9,3.9,0,1,0,0-7.8Zm.1,6H99.2V19.2h2.7a2.2,2.2,0,0,1,2.2,2.1,2.289,2.289,0,0,1-2.2,2.2Zm11.5-1.8a3.361,3.361,0,0,0-3.3,1.9l1.7.7a1.766,1.766,0,0,1,1.7-.9,1.879,1.879,0,0,1,2,1.6v.1a3.967,3.967,0,0,0-1.9-.5c-1.8,0-3.6,1-3.6,2.8a2.93,2.93,0,0,0,3.1,2.8,2.814,2.814,0,0,0,2.4-1.2h.1v1h1.8V25.2a3.785,3.785,0,0,0-4-3.5Zm-.2,6.9c-.6,0-1.5-.3-1.5-1.1,0-1,1.1-1.3,2-1.3a3.867,3.867,0,0,1,1.7.4A2.329,2.329,0,0,1,113.2,28.6ZM123.7,22l-2.1,5.4h-.1L119.3,22h-2l3.3,7.6-1.9,4.2h1.9L125.7,22h-2Zm-16.8,8h1.9V17.5h-1.9Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M10.4,7.5A1.955,1.955,0,0,0,10,8.9V31a1.978,1.978,0,0,0,.5,1.4l.1.1L23,20.1v-.2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M27,24.3l-4.1-4.1v-.3L27,15.8l.1.1L32,18.7c1.4.8,1.4,2.1,0,2.9Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M27.1,24.2,22.9,20,10.4,32.5c.5.5,1.2.5,2.1.1l14.6-8.4",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M27.1,15.8,12.5,7.5a1.621,1.621,0,0,0-2.1.1L22.9,20l4.2-4.2Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M27,24.1,12.5,32.3a1.635,1.635,0,0,1-2,0l-.1.1.1.1a1.635,1.635,0,0,0,2,0Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M10.4,32.3a1.955,1.955,0,0,1-.4-1.4V31a1.978,1.978,0,0,0,.5,1.4v-.1h-.1ZM32,21.3l-5,2.8.1.1L32,21.4A1.662,1.662,0,0,0,33,20C33,20.5,32.6,20.9,32,21.3Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M12.5,7.6,32,18.7c.6.4,1,.8,1,1.3a1.662,1.662,0,0,0-1-1.4L12.5,7.5C11.1,6.7,10,7.3,10,8.9V9C10,7.5,11.1,6.8,12.5,7.6Z",
    fill: "#fff",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f80b781ef9eb735ad29ddc4708a9feaa.svg";
export { ForwardRef as ReactComponent };